var _defs, _path, _g, _rect, _g2, _rect2, _rect3, _path2, _g3, _circle, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4591in",
    viewBox: "0 0 37.042 37.06",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4-3",
    gradientTransform: "matrix(0 0 0 0 140.58 -466.07)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e7867",
    offset: 0
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-181.49 -143.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.49,
    y: 143.62,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "#b3a995",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.31,
    y: 160.92,
    width: 5.409,
    height: 7.7654,
    ry: 2.7045,
    fill: "url(#4-3)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.74,
    y: 148.48,
    width: 14.547,
    height: 16.552,
    ry: 7.2734,
    fill: "#968c77",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.86 167.09c-2.1412-5e-3 -6.1401 0.70482-7.9944 1.7754-3.7571 2.1693-4.177 6.0297-4.1769 10.368v1.4449h24.287v-1.4449c1.1e-4 -4.3384-0.56835-8.3474-4.3255-10.517-1.8379-1.0611-5.6678-1.622-7.7901-1.6268z",
    fill: "#615b4c",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m193.64 166.17v1.6024l6.5407 7.2762 6.1204-7.5126 0.0263-1.1295z",
    fill: "#b3a995",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.48,
    cy: 157.31,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.48,
    cy: 157.31,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.54,
    cy: 157.31,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.54,
    cy: 157.31,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d3cdc3",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m194.98 150.5c-1.2827 1.2282-2.1143 2.9225-2.2262 4.8178 1.2818-0.35761 2.2262-1.6237 2.2262-3.1445z",
    stopColor: "#000000",
    strokeWidth: 0.94374
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.04 150.5v1.6733c0 1.5206 0.9441 2.7867 2.2257 3.1445-0.11188-1.8952-0.94305-3.5896-2.2257-4.8178z",
    stopColor: "#000000",
    strokeWidth: 0.94374
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.6 147.37-0.74981 1.2284c-1.2496 0.0676-2.7337 0.75582-3.9907 2.0133 0.25044 0.13875-0.36026 1.1905-6e-3 1.3029l10.302 0.0157c0.22393-0.0678-6e-3 -1.0514 0.18172-1.13-1.3155-1.7494-3.8342-2.876-5.7369-3.4303z",
    stopColor: "#000000",
    strokeWidth: 2.1258
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 193.03,
    y: 175.42,
    width: 1.9964,
    height: 2.2328,
    fill: "#a19a86",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#7e7867"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-13.588)",
    x: 143.03,
    y: 210.11,
    width: 5.1122,
    height: 1.2389,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.78 166.8a12.143 12.143 0 0 0-0.015 8e-3 12.143 12.143 0 0 0-0.86765 0.55191l0.69091 5.1056 8.478 4.302-1.218-1.4655 5.5898-2.8365 0.65991-4.8741a12.143 12.143 0 0 0-0.96739-0.65216l-6.1174 7.3582z",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.97201 -.23493 -.23493 .97201 0 0)",
    x: -245.44,
    y: 116.22,
    width: 5.1122,
    height: 1.2389,
    stopColor: "#000000"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.97201 -.23493 -.23493 .97201 0 0)",
    x: -245.9,
    y: 115.24,
    width: 5.9921,
    height: 1.3046,
    ry: 0.65229,
    fill: "#615b4c",
    stopColor: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-13.588)",
    x: 142.57,
    y: 209.14,
    width: 5.9921,
    height: 1.3046,
    ry: 0.65229,
    fill: "#615b4c",
    stopColor: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m192.83 158.94-0.45475 6.7334c0 3.8003 3.4178 6.881 7.6336 6.8807 4.2154-1.9e-4 7.6326-3.0807 7.6326-6.8807l-0.45475-6.7334c-1.1352 0.16019-2.0792 0.95438-2.4314 2.0454h-9.4945c-0.35205-1.0908-1.2959-1.885-2.4309-2.0454z",
    fill: "#d3cdc3",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.54916
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#a19a86",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.43,
    y: 174.39,
    width: 4.6757,
    height: 0.81431,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.43,
    y: 175.2,
    width: 1.4447,
    height: 0.76177,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.87,
    y: 175.2,
    width: 1.4447,
    height: 0.76177,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.32,
    y: 175.2,
    width: 1.7862,
    height: 0.76177,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.43,
    y: 175.96,
    width: 1.0547,
    height: 0.76177,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.48,
    y: 175.96,
    width: 2.327,
    height: 0.76177,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.81,
    y: 175.96,
    width: 1.294,
    height: 0.76177,
    stopColor: "#000000"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 194.03,
    cy: 174.85,
    r: 1.276,
    fill: "#c9c2b5",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 195.2,
    y: 159.34,
    width: 9.6186,
    height: 3.3098,
    ry: 1.6549,
    fill: "#d3cdc3",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait16);
export default __webpack_public_path__ + "static/media/player-portrait-16.2e2ccc4a8c06c76398b6a6a9f4ca8299.svg";
export { ForwardRef as ReactComponent };